import {
  Building2,
  FileChartColumn,
  ScrollText,
  LayoutDashboard,
  MousePointerClick,
  Tag,
  UserCog,
  type LucideIcon,
} from 'lucide-react';

import type { PlatformPermission } from '@/lib/permissions';

export interface NavItem {
  to: string;
  icon: LucideIcon;
  label: string;
  /** OS-1717 — capacidad que abre la sección (menú y ruta). */
  permission: PlatformPermission;
}

export const NAV_ITEMS: readonly NavItem[] = [
  { to: '/dashboard', icon: LayoutDashboard, label: 'Dashboard', permission: 'platform.reports.read' },
  { to: '/tenants', icon: Building2, label: 'Tenants', permission: 'platform.tenants.read' },
  /** OS-1723 — lista de precios por módulo (la edita solo SUPER). */
  { to: '/prices', icon: Tag, label: 'Precios', permission: 'platform.billing.read' },
  { to: '/usability', icon: MousePointerClick, label: 'Usabilidad', permission: 'platform.reports.read' },
  /** OS-1726 — visor de auditoría y reportes cross-tenant. */
  { to: '/reports', icon: FileChartColumn, label: 'Reportes', permission: 'platform.reports.read' },
  { to: '/audit', icon: ScrollText, label: 'Auditoría', permission: 'platform.audit.read' },
  { to: '/admins', icon: UserCog, label: 'Administradores', permission: 'platform.admins.manage' },
];
